import { CartRelatedProducts } from './cart-related-products'
import { hideElement, replaceNodeChildren, showElement } from '../../utils/dom'
import { CartPage } from './cart'

import { BaseComponent } from '../../components/base-component'
import { $el, $elParent } from 'src/scripts/utils/utils'

const RELATED_PRODUCTS_SELECTOR = '[data-cart-related-products]'
const CART_PAGE_SELECTOR = 'cart-page'

export class CartRelatedProductsBlock extends BaseComponent {
  mountComponent(): void {
    const cart: CartPage = $elParent(CART_PAGE_SELECTOR, this)
    cart?.on('update-nodes', this.handleCartUpdate)
  }

  unmountComponent(): void {
    const cart: CartPage = $elParent(CART_PAGE_SELECTOR, this)
    cart?.off('update-nodes', this.handleCartUpdate)
  }

  handleCartUpdate = ({ node }): void => {
    const relatedProducts: CartRelatedProducts = $el(
      RELATED_PRODUCTS_SELECTOR,
      this,
    )
    const newRelatedProducts = $el(
      `cart-related-products-block[block-id="${this.getAttribute(
        'block-id',
      )}"] [data-cart-related-products]`,
      node,
    )
    const isAuto = this.hasAttribute('is-auto-recommendations')

    if (!relatedProducts || !newRelatedProducts) {
      return
    }

    if (isAuto) {
      const newUrl = newRelatedProducts.getAttribute('data-url')

      relatedProducts.setAttribute('data-url', newUrl)

      if (newUrl) {
        relatedProducts.loadProducts()
        showElement(this)
      } else {
        relatedProducts.erase()
        hideElement(this)
      }
    } else {
      replaceNodeChildren(relatedProducts, newRelatedProducts)
    }
  }
}
